module.exports = __webpack_public_path__ + "static/img/datiao.00685cdf.png";